import { dateDiffToNow } from '../../util/date-convert'
/* eslint-disable */
const state = {
    corporation: {
      id: '',
      name: '',
      email: '',
      officerName: '',
      sectorsName: '',
      tel: '',
      officerNameKana: '',
      position: '',
      password: '',
      guestNumber: 0,
      contractPeriodTo: '',
      country: '',
      zipCode: '',
      prefectures: '',
      municipalities: '',
      building: '',
      decreaseFlag: false,
      isExpiredCorporation: false,
    },
    sectors: [
      { id: '', name: ''}
    ]
  }

  const getters = {
    getCorporation(state) {
        return state.corporation
    },
    getSectors(state) {
        return state.sectors
    }
  }

  const mutations = {
    setCorporation (state, corporation) {
      state.corporation = corporation
    },
    setSectors (state, sectors) {
      state.sectors = sectors
    }
  }

  const actions = {
    async updateCorporation ({ commit }, corporation) {
      corporation.isExpiredCorporation = state.corporation.isExpiredCorporation
      // 8日後以降は、新規ユーザー登録 ボタンを非活性、お支払いの次へボタンを非活性化
      if (dateDiffToNow(corporation.contractPeriodTo) < -7 ) {
          corporation.isExpiredCorporation = true
      }
      commit('setCorporation', corporation)
    },
    async updateSectors({ commit }, sectors) {
      commit('setSectors', sectors)
    },
    checkAdjournment({}, incompleteTransferCorporation) {
      if (incompleteTransferCorporation !== null) {
        state.corporation.isExpiredCorporation = true
      }
    }
  }

  export default {
    namespaced: false,
    state,
    getters,
    mutations,
    actions
  }



// WEBPACK FOOTER //
// ./src/store/modules/corporation.js